module.exports = __webpack_public_path__ + "static/media/01.16867504.mp3";